import { ChartConstructorType } from 'highcharts-angular';
import { DashboardLineGraphDto } from './../../../../service/dto';
import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-dashboard-line-graph',
	standalone: false,
	templateUrl: './dashboard-line-graph.component.html',
	styleUrl: './dashboard-line-graph.component.scss'
})
export class DashboardLineGraphComponent {
	// @Input() input!: DashboardLineGraphDto;
	_input!: DashboardLineGraphDto;
	chartConstructor: ChartConstructorType = 'chart';
	updateFlag: boolean = true;       // Use this to trigger redraws
	oneToOneFlag: boolean = true;      // True = shared axis updates
	chartOptions!: Highcharts.Options;

	@Input()
	set input(input: DashboardLineGraphDto) {
		this._input = input;


		this.chartOptions = {
			chart: {
				type: 'spline',
				style: {
					fontFamily: "'Inter', system-ui, -apple-system, sans-serif"
				},
				backgroundColor: 'transparent'
			},
			colors: ['#0048b4', '#1a7a5e', '#b6641a', '#5c636d', '#a3293a', '#8aa9d6'],
			title: {
				text: input.title,
				style: {
					fontSize: '13px',
					fontWeight: '600',
					color: '#1a1d23'
				}
			},
			xAxis: {
				categories: input.ticks,
				title: { text: input.xAxisTitle },
				lineColor: '#e2e4e8',
				tickColor: '#e2e4e8',
				labels: { style: { color: '#5c636d', fontSize: '11px' } }
			},
			yAxis: {
				title: {
					text: input.yAxisTitle,
					style: { color: '#5c636d' }
				},
				gridLineColor: '#e2e4e8',
				labels: { style: { color: '#5c636d', fontSize: '11px' } }
			},
			plotOptions: {
				spline: {
					marker: {
						enabled: true,
						radius: 3
					},
					lineWidth: 2.5
				}
			},
			series: input.datasets.map(item => {
				return { name: item.title, type: 'spline', data: item.values };
			}),
			tooltip: {
				shared: true
			},
			credits: {
				enabled: false
			},
			legend: {
				layout: 'horizontal',
				align: 'center',
				verticalAlign: 'bottom',
				itemStyle: { color: '#5c636d', fontWeight: '500', fontSize: '12px' }
			}
		};
	}


}
